<script setup>
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion'
import { cn } from '@/lib/utils';

const props = defineProps({
    title: {
        type: String,
        required: false
    },
    value: {
        type: String,
        required: true
    },
    triggerClass: {
        type: String,
        required: false
    },
    itemClass: {
        type: String,
        required: false
    },
    contentClass: {
        type: String,
        required: false
    }
})

</script>

<template>
  <Accordion type="single" :default-value="value" collapsible>
    <AccordionItem :value="value" :class="itemClass">
      <AccordionTrigger :class="cn('hover:no-underline', triggerClass)">
        <slot name="title">
            {{ title }}
        </slot>
      </AccordionTrigger>
      <AccordionContent :class="cn('pt-0', contentClass)">
        <slot></slot>
      </AccordionContent>
    </AccordionItem>
  </Accordion>
</template>
